import Img from "components/common/Img"

import "./style.styl"

const CustomSelect = ({ items = [], onRadioClick }) => {
  return (
    <ul className="custom-select__list">
      {items.map((item, index) => (
        <li className="list__item" key={`custom-bb-select-${index}`}>
          <input
            className="list__input"
            type="radio"
            name={item.name}
            id={item.value}
            value={item.value}
            onClick={onRadioClick}
          />
          <label htmlFor={item.value}>{item.label}</label>
          <Img alt="Ícone de alerta com ponto de exclamação dentro de um triângulo com pontas arredondadas" src="images/chevron-right-icon.svg" />
        </li>
      ))}
    </ul>
  )
}

export default CustomSelect
